const BookOpenIcon = ({
  className,
  color = '#323232',
  size = 16,
}: {
  className?: string;
  color?: string;
  size?: number;
}) => (
  <svg
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 16 16"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="fi:book-open">
      <path
        d="M14.6667 2H10.6667C9.95942 2 9.28115 2.28095 8.78105 2.78105C8.28095 3.28115 8 3.95942 8 4.66667V14C8 13.4696 8.21071 12.9609 8.58579 12.5858C8.96086 12.2107 9.46957 12 10 12H14.6667V2Z"
        id="Vector"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        stroke={color}
      />
      <path
        d="M1.3335 2H5.3335C6.04074 2 6.71902 2.28095 7.21911 2.78105C7.71921 3.28115 8.00016 3.95942 8.00016 4.66667V14C8.00016 13.4696 7.78945 12.9609 7.41438 12.5858C7.0393 12.2107 6.5306 12 6.00016 12H1.3335V2Z"
        id="Vector_2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        stroke={color}
      />
    </g>
  </svg>
);

export default BookOpenIcon;
